import WithAuth from "../components/hoc/with-auth";
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx";
import { Flex, Text, Box } from "@chakra-ui/react";
import FrequentTradesPage from "../components/pages/frequent-trades-page";
import CreateTransactionsForm from "../components/pages/create-transactions-form";

const CreateTransaction = () => {
  return (
    <>
      <WithAuth>
        <LayoutWithSidebar
          pageTitle="Create Transactions"
          pageDesc="Deposit, Withdraw, Credit In, Credit Out"
        >
          <CreateTransactionsForm />
        </LayoutWithSidebar>
      </WithAuth>
    </>
  );
};

export default CreateTransaction;
